module.exports = __webpack_public_path__ + "static/media/home-hero-xl.8e3b4ddb.gif";